/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const openInNewTab = (url: string): void => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window.open(url, '_blank');
};
